import * as Styled from './PunchupToggle.styles';

import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import {
	PunchupFieldHelp,
	PunchupFieldHelpIcon,
} from 'features/common/components/Punchup/primitives/forms/fields/PunchupFieldLabel';

interface PunchupToggleProps {
	htmlFor: string;
	name: string;
	label?: string;
	info?: string;
	/**
	 * Optional tooltip beside the label. `info` stays the always-visible one-line promise; add `help` only
	 * when the toggle carries mechanics or an example the info line cannot hold.
	 */
	help?: PunchupFieldHelp;
}

export const PunchupToggle: FC<PunchupToggleProps> = ({ htmlFor, name, label, info, help }) => {
	const { register } = useFormContext();

	return (
		<Styled.Container>
			<Styled.LabelContainer>
				{label && (
					<Styled.LabelRow>
						<Styled.Label htmlFor={htmlFor}>{label}</Styled.Label>
						{help && <PunchupFieldHelpIcon help={help} ariaLabel={`${label} — more information`} />}
					</Styled.LabelRow>
				)}
				{info && <Styled.Info>{info}</Styled.Info>}
			</Styled.LabelContainer>

			<Styled.Toggle>
				<input type="checkbox" id={htmlFor} {...register(name)} />
				<Styled.Slider />
			</Styled.Toggle>
		</Styled.Container>
	);
};
